import { cva, type VariantProps } from "class-variance-authority";
import { Column, Container, type ContainerProps, Row } from "../../layout/grid";
import type { InspectorProps } from "../../lib/inspector";
import { cn } from "../../lib/utils";
import {
  TeaserGrid,
  type TeaserItem,
} from "../../patterns/teaser-grid/teaser-grid";

export type TeaserSectionInspectorProps = InspectorProps<"container" | "items">;

export const teaserSectionVariants = cva("", {
  variants: {
    columnWidth: {
      8: "col-span-10 col-start-2 md:col-span-8 md:col-start-3",
      10: "col-span-10 col-start-2",
      12: "col-span-12",
    },
    backgroundColor: {
      black: "bg-black",
      white: "bg-white",
      whitesmoke: "bg-whitesmoke",
    },
  },
  defaultVariants: {
    columnWidth: 12,
  },
});

export type TeaserSectionProps = VariantProps<typeof teaserSectionVariants> & {
  sys?: { id: string };
  items: readonly TeaserItem[];
  className?: string;
  paddingTop?: ContainerProps["paddingTop"];
  paddingBottom?: ContainerProps["paddingBottom"];
  inspectorProps?: TeaserSectionInspectorProps;
};

export function TeaserSection(props: Readonly<TeaserSectionProps>) {
  if (props.items.length === 0) {
    return null;
  }

  const containerClasses = teaserSectionVariants({
    columnWidth: null,
    backgroundColor: props.backgroundColor,
  });

  const columnClasses = teaserSectionVariants({
    columnWidth: props.columnWidth,
    backgroundColor: null,
  });

  return (
    <Container
      className={cn(
        containerClasses,
        "component-teaser-section",
        props.className
      )}
      fullWidth
      paddingBottom={props.paddingBottom}
      paddingTop={props.paddingTop}
      testId="teaser-section"
      {...props.inspectorProps?.container}
    >
      <Row className="gap-0">
        <Column className={columnClasses}>
          <TeaserGrid
            inspectorProps={{ container: props.inspectorProps?.items }}
            items={props.items}
            testId="teaser-section-grid"
          />
        </Column>
      </Row>
    </Container>
  );
}

export type { TeaserItem } from "../../patterns/teaser-grid/teaser-grid";
